import { useNavigate } from "react-router-dom";
import homeStyle from "../styles/Home.module.css";
import { logOut } from "../services/api";

function LogOut(){
  const navigate = useNavigate()
  // Apuntaba a http://localhost:3005 escrito a mano: en produccion el pedido no llegaba a
  // ningun lado, la cookie de sesion quedaba viva y el boton ni siquiera navegaba (el error
  // moria en el catch). Va por el mismo servicio que usa el boton del LayOut, y se sale igual
  // aunque el server falle: quedarse adentro es peor que un logout a medias.
  const handleLogOut = () => {
    logOut()
      .catch(() => {})
      .finally(() => navigate("/"));
  };
  return(
    <button className={homeStyle.boton} onClick={handleLogOut}>
            Cerrar sesion
          </button>
  )
};
 export default LogOut;